import { useEffect } from 'react';

// timeout: number - The time in seconds to wait for inactivity
const useInactivityTimer = (timeout: number, onInactivity: () => void) => {
    useEffect(() => {
        let timer: NodeJS.Timeout;
        const resetTimer = () => {
            clearTimeout(timer);
            // timer = setTimeout(onInactivity, timeout);
            // The time in seconds
            timer = setTimeout(onInactivity, timeout * 1000);
        };

        // Events that reset the timer
        window.addEventListener('mousemove', resetTimer);
        window.addEventListener('keydown', resetTimer);
        window.addEventListener('scroll', resetTimer);
        window.addEventListener('click', resetTimer);
        // Add more events as needed

        // Set initial timer
        resetTimer();

        return () => {
            clearTimeout(timer);
            window.removeEventListener('mousemove', resetTimer);
            window.removeEventListener('keydown', resetTimer);
            window.removeEventListener('scroll', resetTimer);
            window.removeEventListener('click', resetTimer);
            // Remove more events as added above
        };
    }, [timeout, onInactivity]); // Re-run the effect if timeout or onInactivity changes
};

export default useInactivityTimer;
